import { Component, OnInit, OnDestroy, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { EFormService } from '../../../../shared-components/e-forms/e-form.service';
import { EFormMergeField } from '../../../../shared-components/e-forms/e-form-merge-field.model';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Subscription } from 'rxjs';
import * as _ from 'lodash';
import { LoginService } from '../../../../shared-modules/login/login.service';
import { EFormDesignerService } from '../e-form-designer.service';
import { EFormConfiguration, enmEFormViewModes } from '../../e-form-config.model';

@AutoUnsubscribe({ includeArrays: true })
@Component({
  selector: 'app-merge-field-dialog',
  templateUrl: './merge-field-dialog.component.html',
  styleUrls: ['./merge-field-dialog.component.css']
})
export class MergeFieldDialogComponent implements OnInit, OnDestroy {

  mergeFields: EFormMergeField[] = [];
  subscriptions: Subscription[] = [];
  config: EFormConfiguration;
  fieldList: any[] = [];
  @ViewChild(MatSort) sort: MatSort;
  constructor(
    private dialogRef: MatDialogRef<MergeFieldDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private eFormService: EFormService,
    private eFormDesignerService: EFormDesignerService
  ) {
    this.config = (data && data.config) ? data.config : new EFormConfiguration();
  }

  ngOnInit() {
    this.getMergeFields();
    this.subscriptions.push(this.eFormDesignerService.observableCloseMergeFieldWindowStream$.subscribe(result => {
      this.dialogRef.close();
    }));
  }

  ngOnDestroy() { }

  closeClick() {
    this.dialogRef.close();
  }

  getMergeFields() {
    if (!this.eFormService.mergeFields || this.eFormService.mergeFields.length == 0) {
      this.subscriptions.push(this.eFormService.getMergeFields().subscribe(fields => {
        this.eFormService.mergeFields = fields;
        this.filterMergeFields();
        this.organizeMergeFields();
      }));
    }
    else {
      this.filterMergeFields();
      this.organizeMergeFields();
    }
  }

  filterMergeFields() {
    if (this.config.ViewMode == enmEFormViewModes.FRMA) {
      this.mergeFields = this.eFormService.mergeFields.filter( o => o.UseOnFRMA && (this.data.allowStudentSpecificMergeFields || o.FieldName != '<<Child Name>>') && (this.data.allowAdultSpecificMergeFields || o.FieldName != '<<Adult Name>>'));

    }
    else if (this.config.PageFlag) {
      this.mergeFields = this.eFormService.mergeFields.filter(o => o.UseOnStudentForm || o.UseOnStudentGPA);
    }
    else if (this.eFormService.selectedTemplate && this.eFormService.selectedTemplate != undefined && this.eFormService.selectedTemplate.Type) {
      this.mergeFields = this.eFormService.mergeFields.filter(o => (o.UseOnFamilyForm && this.eFormService.selectedTemplate.Type == 'family')
        || ((o.UseOnStudentForm || o.UseOnStudentGPA) && this.eFormService.selectedTemplate.Type == 'student')
        || (o.UseOnBehaviorLetter && this.eFormService.selectedTemplate.Type == 'behavior')
        || (o.UseOnAttendanceLetter && this.eFormService.selectedTemplate.Type == 'attendance'));
    }
    else {
      if (this.eFormService.selectedInstance && this.eFormService.selectedInstance != undefined && this.eFormService.selectedInstance.TemplateType) {
        this.mergeFields = this.eFormService.mergeFields.filter(o => (o.UseOnFamilyForm && this.eFormService.selectedInstance.TemplateType == 'family') || ((o.UseOnStudentForm || o.UseOnStudentGPA) && this.eFormService.selectedInstance.TemplateType == 'student'));
      }
    }
  }

  mergeFieldClicked(field: EFormMergeField) {
    if (this.data && this.data.noOperation) {
      this.eFormDesignerService.observableChoiceMergeFieldClicked.next(field);
    }
    else {
      this.eFormDesignerService.observableMergeFieldClicked.next(field);
    }
  }

  organizeMergeFields() {
    const fieldList: any[] = [];
    let otherCategory: any;  // The "Other" category goes at the end of the list.  Other categories are in alphabetical order
    const categories = _.sortBy(_.uniq(_.map(this.mergeFields, o => o.Category)), o => o);
    categories.forEach(cat => {
      const catObj = {
        category: cat,
        fields: []
      };
      catObj.fields = _.sortBy(this.mergeFields.filter(o => o.Category == cat), o => o.DisplayName);
      if (catObj.category.toLowerCase() == 'other') {
        otherCategory = catObj;
      }
      else {
        fieldList.push(catObj);
      }
    });
    if (otherCategory) {
      fieldList.push(otherCategory);
    }
    this.fieldList = fieldList;
  }

}
